import { ColumnDef } from '@tanstack/react-table';

import { CampaignsTableColumnId } from './CampaignsTableV2ColumnConfig';
import { CampaignsTableRow } from './CampaignsTableV2ColumnsConfig';

/**
 * Default columns displayed in the campaigns table when user hasn't customized.
 * The 'actions' column is always shown (non-configurable) and is not in this list.
 */
export const defaultCampaignsColumnsConfig: CampaignsTableColumnId[] = [
  CampaignsTableColumnId.Campaign,
  CampaignsTableColumnId.EventName,
  CampaignsTableColumnId.EventDate,
  CampaignsTableColumnId.StartDate,
  CampaignsTableColumnId.EndDate,
  CampaignsTableColumnId.Revenue,
  CampaignsTableColumnId.Spend,
  CampaignsTableColumnId.Roas,
  CampaignsTableColumnId.SalesCount,
  CampaignsTableColumnId.ImpressionShare,
  CampaignsTableColumnId.Clicks,
  CampaignsTableColumnId.Budget,
  CampaignsTableColumnId.BudgetRemaining,
  CampaignsTableColumnId.Status,
  CampaignsTableColumnId.Target,
];

/**
 * Minimal column definitions used by ColumnSettingsModal to power the column picker UI.
 * Each entry maps a column ID to a lightweight ColumnDef with just an `id`.
 * The actual column rendering is handled by getTableColumnDefinitions in CampaignsTableV2ColumnsConfig.
 */
export const CAMPAIGNS_TABLE_V2_COLUMNS_SETTINGS_CONFIG: Partial<
  Record<CampaignsTableColumnId, ColumnDef<CampaignsTableRow>>
> = {
  [CampaignsTableColumnId.Campaign]: {
    id: CampaignsTableColumnId.Campaign,
  },
  [CampaignsTableColumnId.EventName]: {
    id: CampaignsTableColumnId.EventName,
  },
  [CampaignsTableColumnId.EventDate]: {
    id: CampaignsTableColumnId.EventDate,
  },
  [CampaignsTableColumnId.StartDate]: {
    id: CampaignsTableColumnId.StartDate,
  },
  [CampaignsTableColumnId.StartTime]: {
    id: CampaignsTableColumnId.StartTime,
  },
  [CampaignsTableColumnId.EndDate]: {
    id: CampaignsTableColumnId.EndDate,
  },
  [CampaignsTableColumnId.PotentialRevenue]: {
    id: CampaignsTableColumnId.PotentialRevenue,
  },
  [CampaignsTableColumnId.Revenue]: {
    id: CampaignsTableColumnId.Revenue,
  },
  [CampaignsTableColumnId.Spend]: {
    id: CampaignsTableColumnId.Spend,
  },
  [CampaignsTableColumnId.Roas]: {
    id: CampaignsTableColumnId.Roas,
  },
  [CampaignsTableColumnId.PotentialSales]: {
    id: CampaignsTableColumnId.PotentialSales,
  },
  [CampaignsTableColumnId.SalesCount]: {
    id: CampaignsTableColumnId.SalesCount,
  },
  [CampaignsTableColumnId.HistoricPotentialImpressions]: {
    id: CampaignsTableColumnId.HistoricPotentialImpressions,
  },
  [CampaignsTableColumnId.ActualImpressions]: {
    id: CampaignsTableColumnId.ActualImpressions,
  },
  [CampaignsTableColumnId.ImpressionShare]: {
    id: CampaignsTableColumnId.ImpressionShare,
  },
  [CampaignsTableColumnId.Clicks]: {
    id: CampaignsTableColumnId.Clicks,
  },
  [CampaignsTableColumnId.Cpc]: {
    id: CampaignsTableColumnId.Cpc,
  },
  [CampaignsTableColumnId.Budget]: {
    id: CampaignsTableColumnId.Budget,
  },
  [CampaignsTableColumnId.BudgetRemaining]: {
    id: CampaignsTableColumnId.BudgetRemaining,
  },
  [CampaignsTableColumnId.Status]: {
    id: CampaignsTableColumnId.Status,
  },
  [CampaignsTableColumnId.Strategy]: {
    id: CampaignsTableColumnId.Strategy,
  },
  [CampaignsTableColumnId.Target]: {
    id: CampaignsTableColumnId.Target,
  },
  [CampaignsTableColumnId.IncrementalSellerProceeds]: {
    id: CampaignsTableColumnId.IncrementalSellerProceeds,
  },
  [CampaignsTableColumnId.Actions]: {
    id: CampaignsTableColumnId.Actions,
  },
};
